import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {Box, Checkbox, Stack, Typography} from '@mui/material';
import {useEffect, useRef, useState} from 'react';
import axios from 'axios';
import {useSelector} from 'react-redux';
import {constance} from "../../common/constance/constance";
import {RootState} from "../../reducer";
import {common} from "../../common/common";

const sha256 = require('sha256');

/* 도서대여 페이지 알람 */
export default function ApplyBookRentalDialog(props: { state: any, setState: any, application: any }) {
    console.log('[ApplyBookRentalDialog]');
    const bookOneLineReviewRef: any = useRef();

    const [state, setState] = useState({
        checked: false,
        bookOneLineReview: ''
    })

    const handleClose = () => {
        props.setState({
            ...props.state,
            openDialog: false
        })
    };

    function handleCheckBox(e: React.ChangeEvent<HTMLInputElement>) {
        setState({
            ...state,
            checked: e.target.checked
        })
    }

    function saveBookApplication() {
        if (props.state.isReturn && !bookOneLineReviewRef.current.value) {
            // common.alert('다음 사람을 위해 한줄평을 입력해주세요', '', 'info');
            return;
        }
        props.setState({
            ...props.state,
            openDialog: false
        })
        props.application(state.bookOneLineReview);
    }

    function handlePointerOut(e: any) {
        setState({
            ...state,
            bookOneLineReview: bookOneLineReviewRef.current.value
        })
    }

    return (
        <Box sx={{}}>
            <Dialog open={props.state.openDialog} onClose={handleClose} sx={{maxHeight: '100vh',}}>
                {/*<DialogTitle>*/}
                {/*</DialogTitle>*/}
                <DialogContent sx={{backgroundImage: 'url(/images/book-application-background.png)'}}>
                    <DialogContentText>
                        <Typography variant={'h4'} align={'center'}
                                    sx={{color: '#fff', letterSpacing: '8px'}}>{'도서대출규정'}</Typography>
                        <Stack sx={{mt: 2, backgroundColor: 'var(--scc-surface)', p: 2, borderRadius: 2}}>
                            <Typography variant={'h6'} sx={{mb: 2}}>
                                {`1. 대출기간 : 2주`}
                            </Typography>
                            <Typography variant={'h6'} sx={{mb: 1}}>
                                {/*{`2. 기간연장 : 최대 1회(2주)에 한하여 연장 가능`}*/}
                                {`2. 기간연장 : 불가`}
                            </Typography>
                            <Box sx={{display: 'flex'}}>
                                <Typography variant={'h6'} sx={{mb: 2}}>
                                    {`3. 도서반납 : `}
                                </Typography>
                                <Stack>
                                <Typography variant={'h6'} sx={{ml: 1, color: '#fc0000'}}>
                                    {`총무팀 송영훈 담당에게 직접 반납`}
                                </Typography>
                                <Typography variant={'h6'} sx={{mb: 2, ml: 1}}>
                                    {`반납시 한줄평 필수`}
                                </Typography>
                                </Stack>
                            </Box>

                            <Typography variant={'h6'} align={'center'} sx={{mb: 2, color: '#0f2ed5'}}>
                                {`★ 살포시 식당에 놓으시면 안 됩니다. ★`}
                            </Typography>
                        </Stack>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>


                    <Stack sx={{width: 1}}>
                        {
                            props.state.isReturn ?
                                <Box sx={{p: 2, width: 1, display: 'flex', justifyContent:"center"}}>
                                    <TextField inputRef={bookOneLineReviewRef}
                                               defaultValue={''}
                                               type={'text'}
                                               label="" variant="outlined"
                                               placeholder={"한줄평을 입력해주세요!"}
                                               autoFocus={true}
                                               onPointerOut={handlePointerOut}
                                               sx={{width: 1, backgroundColor: 'var(--scc-surface)', borderRadius: 1}}
                                    />
                                </Box>
                                :
                                <></>
                        }
                        <Box sx={{display: 'flex', alignItems: 'center', width: 1, justifyContent: 'flex-end'}}>
                            <Typography>위 내용을 확인하였습니다. </Typography>
                            <Checkbox value={state.checked}
                                      onChange={(e) => handleCheckBox(e)}/>
                            <Button variant={"contained"} color={'error'} sx={{ml: 3, mr: 1}}
                                    onClick={handleClose}>취소</Button>
                            <Button disabled={!state.checked || (props.state.isReturn && state.bookOneLineReview == '')} variant={"contained"} color={'neutral'}
                                    onClick={saveBookApplication}>{props.state.isReturn ? "반납하기" : "신청하기"}</Button>
                        </Box>
                    </Stack>


                </DialogActions>
            </Dialog>
        </Box>
    );
}
